import { PieChart } from '@mui/x-charts/PieChart';
import './DonutChart.css';

interface PieChartData {
  label: string;
  value: number;
  color?: string;
}

interface DonutChartProps {
  data: PieChartData[];
}

const COLORS = [
  '#67AEFF',
  '#FF89A0',
  '#FFF3B5',
  '#0088FE',
  '#00C49F',
  '#FFBB28',
];

export default function DonutChart({ data }: DonutChartProps) {
  const chartData = data.map((item, index) => {
    return {
      ...item,
      color: item.color || COLORS[index % COLORS.length],
    };
  });

  if (!data || data.length === 0) {
    return (
      <div
        style={{
          height: 246,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: '#A7A3E2',
        }}
      >
        Keine Daten verfügbar
      </div>
    );
  }

  return (
    <PieChart
      series={[
        {
          innerRadius: 80,
          outerRadius: 110,
          startAngle: -300,
          data: chartData,
        },
      ]}
      width={246}
      height={246}
      slotProps={{
        legend: {
          direction: 'horizontal',
          position: { vertical: 'bottom', horizontal: 'center' },
        },
      }}
    />
  );
}
